import {FileManager} from '../../shared/Models/FileManager';
import {DownloadFile} from './DownloadFile';

export class Download {
  static DOWNLOAD_ACTIVE = 'active';
  static DOWNLOAD_INACTIVE = 'inactive';
  public id: number;
  public categoryName: string;
  public description: string;
  public status: string;
  public downloadFiles: DownloadFile[];
}
